
            const data = {"name":"left","data":{"width":"10","height":"16","viewBox":"0 0 10 16","data":"<path pid=\"0\" d=\"M1.079 7.47l6.073-6.073a.75.75 0 011.061 0l.708.708a.75.75 0 01.002 1.06L4.109 8l4.813 4.836a.75.75 0 010 1.06l-.71.708a.75.75 0 01-1.06 0L1.08 8.53a.75.75 0 010-1.06z\" _fill=\"currentColor\"/>"}}
        
                module.exports = data
                